import { ManifestType } from '@clientos/types/dist';
import { ManifestRouteEnhancer } from './ManifestRouteEnhancer';
import { ManifestTenantEnhancer } from './ManifestTenantEnhancer';
import { ManifestWebAppEnhancer } from './ManifestWebAppEnhancer';

/**
 * Main orchestrator for manifest enhancements
 * Coordinates different enhancement modules to process manifests
 */
export class ManifestEnhancerFactory {
  /**
   * Applies all manifest enhancements in the correct order
   */
  static async enhanceManifest(
    manifest: ManifestType,
    isNative: boolean
  ): Promise<ManifestType> {
    try {
      // Apply route enhancements
      ManifestRouteEnhancer.enhanceNativeRoutes(manifest);

      // Apply tenant handler retrocompatibility
      ManifestTenantEnhancer.adaptOrgAndCustomerSelectorIntoTenantHandler(
        manifest
      );

      if (isNative) {
        await ManifestWebAppEnhancer.processWebManifestIntoAppManifest(
          manifest
        );
      }

      return manifest;
    } catch (error) {
      console.error('Error during manifest enhancement:', error);

      // Return original manifest if enhancement fails
      return manifest;
    }
  }
}
